/**
 * Promo Display Logic Hook
 * Determines what promo component should be shown based on context
 */
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageContext } from '../utils/promoUtils';
import { DISPLAY_MODES } from '../utils/promoConstants';
export var usePromoDisplay = function usePromoDisplay() {
  var location = useLocation();

  /**
   * Determine what promo component should be displayed
   */
  var getDisplayConfiguration = useCallback(function (promoCode, dropOffState) {
    var defaultPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'bottom';
    if (!promoCode) {
      return {
        showPopup: false,
        showButton: false,
        showTag: false,
        displayMode: DISPLAY_MODES.NONE,
        position: defaultPosition
      };
    }
    var searchParams = new URLSearchParams(location.search);
    var pageContext = getPageContext(location.pathname, searchParams, promoCode.post_id);
    var isOnPromoPost = pageContext.isOnPromoPost,
      isOnShopApplyPage = pageContext.isOnShopApplyPage,
      isOnConversionPage = pageContext.isOnConversionPage,
      isOnConversionForOtherPromoPosts = pageContext.isOnConversionForOtherPromoPosts;
    var hasDroppedOff = dropOffState.hasDroppedOff,
      promocode_visible = dropOffState.promocode_visible;
    var displayMode = DISPLAY_MODES.NONE;

    // Priority 1: Show tag on shop-apply page for the same promo
    if (isOnShopApplyPage && promocode_visible) {
      displayMode = DISPLAY_MODES.TAG;
    }
    // Priority 2: Display none on conversion pages of another posts
    else if (isOnConversionForOtherPromoPosts) {
      displayMode = DISPLAY_MODES.NONE;
    }
    // Priority 2: Show button on promo post page (not conversion)
    else if (promocode_visible && hasDroppedOff && !isOnConversionPage && (!promoCode.closed_at || !dropOffState.closed_at)) {
      displayMode = DISPLAY_MODES.POPUP;
    }
    // Priority 3: Show popup on other pages if dropped off
    else if (isOnPromoPost && promocode_visible) {
      displayMode = DISPLAY_MODES.BUTTON;
    }
    return {
      showPopup: displayMode === DISPLAY_MODES.POPUP,
      showButton: displayMode === DISPLAY_MODES.BUTTON,
      showTag: displayMode === DISPLAY_MODES.TAG,
      displayMode: displayMode,
      position: defaultPosition
    };
  }, [location.pathname, location.search]);
  return {
    getDisplayConfiguration: getDisplayConfiguration
  };
};